import React from "react";

const ConnectionStatus = React.memo(function ConnectionStatus({ connected, mode }) {
  const modeLabel = mode === 'live' ? 'LIVE' : mode === 'simulation' ? 'SIM' : mode?.toUpperCase() || '';

  return (
    <div
      data-testid="connection-status"
      className="flex items-center justify-between px-3 py-2 rounded-[6px] border font-mono text-xs"
      style={{
        backgroundColor: connected ? '#0a2a1a' : '#2a1418',
        borderColor: connected ? '#14532d' : '#7f1d1d',
        color: connected ? '#22c55e' : '#ef4444',
      }}
    >
      <div className="flex items-center gap-2">
        <span
          className={connected ? 'cw-live-dot' : ''}
          style={{
            display: 'inline-block',
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: connected ? '#22c55e' : '#ef4444',
          }}
        />
        {connected ? 'Connected to backend' : 'Disconnected'}
      </div>
      {mode && (
        <span
          className="font-mono text-[10px] tracking-[0.08em] uppercase px-1.5 py-0.5 rounded"
          style={{
            backgroundColor: mode === 'live' ? 'rgba(34, 197, 94, 0.15)' : 'rgba(245, 158, 11, 0.15)',
            color: mode === 'live' ? '#22c55e' : '#f59e0b',
            border: `1px solid ${mode === 'live' ? 'rgba(34, 197, 94, 0.3)' : 'rgba(245, 158, 11, 0.3)'}`,
          }}
        >
          {modeLabel}
        </span>
      )}
    </div>
  );
});

export default ConnectionStatus;
